
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/content/qna/write",
      function () {
        return require("private-next-pages/content/qna/write/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/content/qna/write"])
      });
    }
  